import React, { useState } from 'react';
import '../styles/FeedbackPage.css';

function Feedback() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    category: 'feedback'
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => {
      setFormData({ name: '', email: '', phone: '', message: '', category: 'feedback' });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="feedback-page">
      <div className="feedback-container">
        <div className="feedback-header">
          <h1>फीडबैक फॉर्म</h1>
          <p>अपनी राय और सुझाव हमारे साथ साझा करें</p>
        </div>

        <div className="feedback-content">
          <div className="feedback-info">
            <div className="info-box">
              <h3>📞 हमसे संपर्क करें</h3>
              <p><strong>Email:</strong> feedback@latthsaab.com</p>
              <p><strong>Phone:</strong> +91-9999-XXXXX</p>
              <p><strong>Office Hours:</strong> 9AM - 6PM, सोमवार से शुक्रवार</p>
            </div>

            <div className="info-box">
              <h3>📋 फीडबैक के प्रकार</h3>
              <ul>
                <li>सामान्य प्रतिक्रिया</li>
                <li>समाचार सुझाव</li>
                <li>तकनीकी समस्या</li>
                <li>शिकायत</li>
                <li>सुधार के सुझाव</li>
              </ul>
            </div>
          </div>

          <div className="feedback-form-wrapper">
            {submitted ? (
              <div className="success-message">
                ✅ धन्यवाद! आपकी प्रतिक्रिया सफलतापूर्वक भेजी गई है।
              </div>
            ) : (
              <form className="feedback-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>नाम *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="अपना नाम दर्ज करें"
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="आपका ईमेल"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>फोन</label>
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="आपका फोन"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>फीडबैक की श्रेणी *</label>
                  <select
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="feedback">सामान्य फीडबैक</option>
                    <option value="news-suggestion">समाचार सुझाव</option>
                    <option value="technical">तकनीकी समस्या</option>
                    <option value="complaint">शिकायत</option>
                    <option value="improvement">सुधार का सुझाव</option>
                  </select>
                </div>

                <div className="form-group">
                  <label>संदेश *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="अपना संदेश दर्ज करें..."
                    rows={6}
                    required
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">भेजें </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
